import { z } from 'zod';

const grammarSessionResultSchema = z.object({
  pointId: z.number().int().positive(),
  itemId: z.number().int().positive(),
  correct: z.boolean(),
  attempt: z.number().int().positive(),
});

const saveGrammarSessionV1RequestSchemaDefinition = z.object({
  sessionKind: z.enum(['lesson', 'workout']),
  results: z.array(grammarSessionResultSchema).min(1),
});

export const saveGrammarSessionV1RequestSchema: typeof saveGrammarSessionV1RequestSchemaDefinition =
  saveGrammarSessionV1RequestSchemaDefinition;

export type ISaveGrammarSessionV1Request = z.infer<typeof saveGrammarSessionV1RequestSchema>;

export type IGrammarSessionResult = ISaveGrammarSessionV1Request['results'][number];
